module.exports = __webpack_public_path__ + "media/integrations/ali-d9a47af6.svg";